(function () {
  var previewCopyElement = document.querySelector('[data-pricing-preview-copy]');
  var previewCopy = previewCopyElement ? JSON.parse(previewCopyElement.textContent) : {
    currency: null,
    cta: 'Temporarily unavailable'
  };
  var previewUsd = previewCopy.currency === 'USD';
  var releasePlans = {4: '10185113919', 6: '10185146687', 8: '10185179455', 12: '10185212223'};
  var releaseHandles = ['elbows', 'fettuccine', 'lasagna', 'linguine', 'penne', 'rotini', 'spaghetti', 'variety-s', 'variety-spagheti', 'no-carb-spaghetti', 'variety', 'gnocchi', 'gnocchi-keto', 'gnocchi-lite', 'gnocchi-pro'];

  function releasePrice(root, variant) {
    if (releaseHandles.indexOf(root.getAttribute('data-product-handle')) === -1) return null;
    var match = String(variant.title).match(/\b(3|6|12)\s*(?:pack)?\b/i);
    if (!match) return null;
    return (root.getAttribute('data-product-handle') === 'gnocchi-pro'
      ? {3: 2799, 6: 5199, 12: 9899}
      : {3: 3600, 6: 6000, 12: 11400})[match[1]];
  }

  function renewalPriceFor(allocation) {
    var adjustment = (allocation && allocation.price_adjustments || []).find(function (item) {
      return Number(item.position) === 2;
    });
    return adjustment ? Number(adjustment.price) : null;
  }

  function previewText(key, values) {
    return Object.keys(values || {}).reduce(function (text, key) {
      return text.replace('[' + key + ']', values[key]);
    }, String(previewCopy[key] || ''));
  }

  function money(cents) {
    var currency = previewCopy.currency || window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: currency
    }).format(Number(cents || 0) / 100);
  }

  function selectedOptions(root) {
    return Array.from(root.querySelectorAll('[data-simple-option-group]')).map(function (group) {
      var checked = group.querySelector('input:checked');
      return checked ? checked.value : '';
    });
  }

  function findVariant(variants, options) {
    return variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === options[index];
      });
    });
  }

  function selectedPurchaseType(root) {
    return (
      root.querySelector('input[name^="purchaseType-"]:checked') ||
      root.querySelector('input[name="simple_purchase_type"]:checked')
    );
  }

  function isSubscriptionPurchase(purchaseType) {
    if (!purchaseType) return false;

    return purchaseType.value === 'subscription' || purchaseType.value === 'purchaseTypeSubscription';
  }

  function discountPercent(comparePrice, price) {
    comparePrice = Number(comparePrice || 0);
    price = Number(price || 0);
    if (!comparePrice || price >= comparePrice) return 0;

    return Math.round(((comparePrice - price) / comparePrice) * 100);
  }

  function servingCount(variant, servingsPerBag) {
    var title = [variant && variant.title].concat(variant && variant.options ? variant.options : []).join(' ');
    var packMatch = title.match(/\b(3|6|12)\s*(pack)?\b/i);
    var packCount = packMatch ? Number(packMatch[1]) : 3;

    return Math.max(1, packCount * (servingsPerBag || 4));
  }

  function servingPrice(price, variant, servingsPerBag) {
    return money(Number(price || 0) / servingCount(variant, servingsPerBag)) + '/serving';
  }

  function preorderState(root, variant) {
    var configElement = root.querySelector('[data-simple-preorder-config]');
    var fallback = {
      active: false,
      allowSubscription: false,
      buttonLabel: 'Pre-order now',
      message: '',
      shipDate: '',
      shippingLine: 'Ships when back in stock',
    };

    if (!configElement || !variant) return fallback;

    try {
      var config = JSON.parse(configElement.textContent);
      var variantConfig = config.variants && config.variants[String(variant.id)];
      fallback.active = Boolean(config.enabled && variantConfig && variantConfig.active);
      fallback.allowSubscription = Boolean(config.allowSubscription);
      fallback.buttonLabel = config.buttonLabel || fallback.buttonLabel;
      fallback.message = config.message || fallback.message;
      fallback.shipDate = config.shipDate || fallback.shipDate;
      fallback.shippingLine = config.shippingLine || fallback.shippingLine;
    } catch (error) {
      console.warn('[Pete\'s Preorder] Invalid preorder configuration', error);
    }

    return fallback;
  }

  function preorderCountdown(shipDate) {
    if (!shipDate) return 'soon';

    var parts = String(shipDate).split('-').map(Number);
    if (parts.length !== 3 || parts.some(function (part) { return !Number.isFinite(part); })) return 'soon';

    var today = new Date();
    var todayUtc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    var shipUtc = Date.UTC(parts[0], parts[1] - 1, parts[2]);
    var days = Math.ceil((shipUtc - todayUtc) / 86400000);

    if (days <= 0) return 'today';
    if (days === 1) return '1 day';
    return days + ' days';
  }

  function syncPreorderState(root, state) {
    var lockSubscription = state.active && !state.allowSubscription;

    root.querySelectorAll('[data-simple-subscription-purchase]').forEach(function (row) {
      if (lockSubscription) {
        if (!row.hidden) row.setAttribute('data-simple-preorder-hidden', 'true');
        row.hidden = true;
      } else if (row.hasAttribute('data-simple-preorder-hidden')) {
        row.hidden = false;
        row.removeAttribute('data-simple-preorder-hidden');
      }

      row.querySelectorAll('input, select').forEach(function (control) {
        if (lockSubscription) {
          if (!control.disabled) control.setAttribute('data-simple-preorder-disabled', 'true');
          control.disabled = true;
        } else if (control.hasAttribute('data-simple-preorder-disabled')) {
          control.disabled = false;
          control.removeAttribute('data-simple-preorder-disabled');
        }
      });
    });

    if (lockSubscription) {
      var oneTimeInput = root.querySelector('[data-simple-one-time-purchase] input[type="radio"]');
      if (oneTimeInput) oneTimeInput.checked = true;
    }

    root.querySelectorAll('[data-simple-preorder-internal], [data-simple-preorder-property]').forEach(function (input) {
      input.disabled = !state.active;
    });

    var propertyInput = root.querySelector('[data-simple-preorder-property]');
    if (propertyInput) propertyInput.value = state.message;

    var notice = root.querySelector('[data-simple-preorder-notice]');
    if (notice) notice.hidden = !state.active;

    var noticeMessage = root.querySelector('[data-simple-preorder-message]');
    if (noticeMessage) noticeMessage.textContent = state.message;

    var countdown = root.querySelector('[data-simple-preorder-countdown]');
    if (countdown) countdown.textContent = preorderCountdown(state.shipDate);

    root.querySelectorAll('[data-simple-delivery-primary]').forEach(function (target) {
      if (!target.hasAttribute('data-simple-default-delivery')) {
        target.setAttribute('data-simple-default-delivery', target.textContent.trim());
      }

      var defaultDelivery = target.getAttribute('data-simple-default-delivery');
      var freeShippingSeparator = defaultDelivery.indexOf('·');
      var freeShippingSuffix = freeShippingSeparator === -1 ? '' : ' · ' + defaultDelivery.slice(freeShippingSeparator + 1).trim();
      target.textContent = state.active ? state.shippingLine + freeShippingSuffix : defaultDelivery;
    });

    var form = root.querySelector('[data-simple-form]');
    if (form) form.setAttribute('data-preorder-active', String(state.active));

    return selectedPurchaseType(root);
  }

  function visibleGalleryThumbs(root) {
    return Array.from(root.querySelectorAll('[data-simple-thumb]')).filter(function (thumb) {
      return !thumb.hidden;
    });
  }

  function scrollThumbIntoView(thumb) {
    if (!thumb) return;

    var track = thumb.closest('[data-simple-gallery-track], [data-pdpb-thumbs]');
    if (!track || typeof track.scrollTo !== 'function') return;

    var trackRect = track.getBoundingClientRect();
    var thumbRect = thumb.getBoundingClientRect();
    var nextLeft =
      track.scrollLeft + thumbRect.left - trackRect.left - (track.clientWidth - thumbRect.width) / 2;

    track.scrollTo({ left: Math.max(0, nextLeft), behavior: 'smooth' });
  }

  function setMainImage(root, thumb) {
    var image = root.querySelector('[data-simple-main-image]');
    if (!image || !thumb) return;

    var src = thumb.getAttribute('data-src');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = src;
    image.alt = thumb.getAttribute('data-alt') || image.alt;
    root.querySelectorAll('[data-simple-thumb]').forEach(function (item) {
      item.classList.toggle('is-active', item === thumb);
    });
    scrollThumbIntoView(thumb);
  }

  function moveGallery(root, direction) {
    var thumbs = visibleGalleryThumbs(root);
    if (thumbs.length < 2) return;

    var active = root.querySelector('[data-simple-thumb].is-active:not([hidden])');
    var activeIndex = thumbs.indexOf(active);
    if (activeIndex === -1) activeIndex = 0;

    var nextIndex = activeIndex + direction;
    if (nextIndex < 0 || nextIndex >= thumbs.length) return;
    setMainImage(root, thumbs[nextIndex]);
  }

  function wireGallerySwipe(root) {
    var target = root.querySelector('.simple-pdp__main-image') || root.querySelector('[data-simple-gallery-track]');
    if (!target || target.dataset.simpleGallerySwipeReady === 'true') return;
    target.dataset.simpleGallerySwipeReady = 'true';

    var startX = 0;
    var startY = 0;
    var startTime = 0;

    target.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        startTime = Date.now();
      },
      { passive: true }
    );

    target.addEventListener(
      'touchend',
      function (event) {
        if (!event.changedTouches || event.changedTouches.length !== 1) return;

        var deltaX = event.changedTouches[0].clientX - startX;
        var deltaY = event.changedTouches[0].clientY - startY;
        var elapsed = Date.now() - startTime;
        if (elapsed > 700 || Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.4) return;

        moveGallery(root, deltaX < 0 ? 1 : -1);
      },
      { passive: true }
    );
  }

  function updateGallery(root, variant) {
    var thumbs = Array.from(root.querySelectorAll('[data-simple-thumb]'));
    if (!thumbs.length || !variant) return;

    var variantId = String(variant.id);
    var visibleThumbs = [];

    thumbs.forEach(function (thumb) {
      var variantIds = (thumb.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
      var isVisible = !variantIds.length || variantIds.indexOf(variantId) !== -1;
      thumb.hidden = !isVisible;
      if (isVisible) visibleThumbs.push(thumb);
    });

    var currentActive = root.querySelector('[data-simple-thumb].is-active:not([hidden])');
    if (currentActive) return;

    var variantImageId = variant.featured_image && variant.featured_image.id ? String(variant.featured_image.id) : '';
    var variantThumb = variantImageId
      ? visibleThumbs.find(function (thumb) {
          return thumb.getAttribute('data-image-id') === variantImageId;
        })
      : null;

    setMainImage(root, variantThumb || visibleThumbs[0]);
  }

  function update(root) {
    var servingsPerBag = Number(root.getAttribute('data-simple-servings-per-bag')) || 4;
    var variants = JSON.parse(root.querySelector('[data-simple-variants]').textContent);
    if (!variants.length) return;
    variants.forEach(function (item) {
      if (!releasePrice(root, item)) return;
      item.selling_plan_allocations = (item.selling_plan_allocations || []).filter(function (allocation) {
        return Object.values(releasePlans).indexOf(String(allocation.selling_plan_id)) !== -1;
      });
    });
    var variant = findVariant(variants, selectedOptions(root)) || variants[0];
    var expectedPrice = releasePrice(root, variant);
    var cadenceControl = root.querySelector('[data-simple-preview-cadence]');
    var cadencePlanId = releasePlans[cadenceControl ? cadenceControl.value : '4'];
    var cadenceAllocation = (variant.selling_plan_allocations || []).find(function (allocation) {
      return String(allocation.selling_plan_id) === cadencePlanId;
    }) || null;
    if (cadenceControl) {
      Array.from(cadenceControl.options).forEach(function (option) {
        option.disabled = !(variant.selling_plan_allocations || []).some(function (allocation) {
          return String(allocation.selling_plan_id) === releasePlans[option.value];
        });
      });
    }
    var currentPreorderState = preorderState(root, variant);
    var purchaseType = syncPreorderState(root, currentPreorderState);
    var sellingPlanInput = root.querySelector('[name="selling_plan"]');
    var variantInput = root.querySelector('[name="id"]');
    var submitButtons = root.querySelectorAll('[data-simple-submit]');
    var priceTargets = root.querySelectorAll('[data-simple-price]');
    var oneTimePriceTargets = root.querySelectorAll('[data-simple-one-time-price]');
    var compareTargets = root.querySelectorAll('[data-simple-compare-price]');
    var subscriptionPriceTargets = root.querySelectorAll('[data-simple-subscription-price]');
    var subscriptionCompareTargets = root.querySelectorAll('[data-simple-subscription-compare]');
    var subscriptionBadgeTargets = root.querySelectorAll('[data-simple-subscription-badge]');
    var subscriptionServingTargets = root.querySelectorAll('[data-simple-subscription-serving]');
    var oneTimeServingTargets = root.querySelectorAll('[data-simple-one-time-serving]');
    var subscriptionTodayDiscountTargets = root.querySelectorAll('[data-simple-subscription-today-discount]');
    var stickyTitle = root.querySelector('[data-simple-sticky-title]');
    var selectedAllocation = null;

    if (isSubscriptionPurchase(purchaseType)) {
      selectedAllocation = cadenceAllocation;
    }

    if (variantInput) variantInput.value = variant.id;
    if (sellingPlanInput) {
      sellingPlanInput.value = selectedAllocation ? selectedAllocation.selling_plan_id : '';
      sellingPlanInput.disabled = !selectedAllocation;
    }

    var displayPrice = selectedAllocation ? selectedAllocation.price : variant.price;
    var subscriptionComparePrice = Number(variant.price);
    priceTargets.forEach(function (target) {
      target.textContent = money(displayPrice);
    });
    oneTimePriceTargets.forEach(function (target) {
      target.textContent = money(variant.price);
    });

    var firstAllocation = cadenceAllocation;
    var firstAllocationDiscount = firstAllocation ? discountPercent(subscriptionComparePrice, firstAllocation.price) : 0;
    subscriptionPriceTargets.forEach(function (target) {
      target.textContent = firstAllocation ? money(firstAllocation.price) : 'Unavailable';
    });

    subscriptionCompareTargets.forEach(function (target) {
      target.textContent = money(subscriptionComparePrice);
      target.hidden = !firstAllocation || firstAllocation.price >= subscriptionComparePrice;
      target.style.display = target.hidden ? 'none' : '';
    });

    subscriptionBadgeTargets.forEach(function (target) {
      target.textContent = firstAllocationDiscount + '% Off';
      target.hidden = !firstAllocationDiscount;
    });

    subscriptionServingTargets.forEach(function (target) {
      target.textContent = servingPrice(firstAllocation ? firstAllocation.price : variant.price, variant, servingsPerBag);
      target.hidden = !firstAllocation;
    });

    oneTimeServingTargets.forEach(function (target) {
      target.textContent = servingPrice(variant.price, variant, servingsPerBag);
    });

    subscriptionTodayDiscountTargets.forEach(function (target) {
      target.textContent = firstAllocationDiscount + '%';
    });

    var laterAdjustments = firstAllocation && firstAllocation.price_adjustments || [];
    var laterAdjustment = laterAdjustments.find(function (item) { return Number(item.position) === 2; }) || laterAdjustments[laterAdjustments.length - 1];
    var renewalPrice = laterAdjustment && Number(laterAdjustment.price);
    if (!Number.isFinite(renewalPrice) || renewalPrice <= 0) renewalPrice = firstAllocation ? Number(firstAllocation.price) : Number(variant.price);
    var renewalDiscount = discountPercent(variant.price, renewalPrice);
    root.querySelectorAll('[data-simple-subscription-renewal-discount]').forEach(function (target) {
      target.textContent = renewalDiscount + '%';
    });
    root.querySelectorAll('[data-simple-subscription-discount]').forEach(function (target) {
      target.textContent = renewalDiscount + '% off after your first order';
    });
    root.querySelectorAll('[data-simple-subscription-discount-value]').forEach(function (target) {
      target.textContent = firstAllocationDiscount + '%';
    });
    root.querySelectorAll('[data-simple-subscription-heading]').forEach(function (target) {
      target.textContent = firstAllocation ? 'Extra ' + firstAllocationDiscount + '% off your first order' : 'Subscription unavailable for this interval';
    });
    root.querySelectorAll('[data-simple-subscription-timing]').forEach(function (target) {
      target.textContent = firstAllocation ? previewCopy.savings : 'Please choose another interval or one-time purchase.';
    });
    var packTitle = [variant.title].concat(variant.options || []).join(' ');
    var packMatch = packTitle.match(/\b(3|6|12)\s*(?:pack)?\b/i);
    var bagCount = packMatch ? Number(packMatch[1]) : 1;
    var cadence = root.querySelector('[data-simple-preview-cadence]');
    var weeks = cadence ? cadence.value : '4';
    root.querySelectorAll('[data-simple-subscription-purchase] [data-simple-cadence-copy]').forEach(function (target) {
      target.textContent = previewText('weeks', {count: weeks});
    });
    root.querySelectorAll('[data-simple-subscription-summary]').forEach(function (target) {
      target.hidden = !firstAllocation;
      target.textContent = previewText('summary', {first: money(firstAllocation ? firstAllocation.price : variant.price), renewal: money(renewalPrice), weeks: weeks});
    });
    root.querySelectorAll('[data-simple-price-context]').forEach(function (target) {
      target.textContent = isSubscriptionPurchase(purchaseType) ? previewCopy.first_bag : previewCopy.one_time_bag;
    });
    root.querySelectorAll('[data-simple-one-time-unit]').forEach(function (target) {
      target.textContent = money(Math.round(Number(variant.price) / bagCount)) + '/bag';
    });
    root.querySelectorAll('[data-simple-option-group]').forEach(function (group, groupIndex) {
      group.querySelectorAll('label.simple-pdp__option').forEach(function (label) {
        var radio = label.querySelector('input[type="radio"]');
        if (!radio) return;
        var values = selectedOptions(root);
        values[groupIndex] = radio.value;
        var optionVariant = findVariant(variants, values);
        if (!optionVariant) return;
        var match = String(optionVariant.title).match(/\b(3|6|12)\s*(?:pack)?\b/i);
        var size = match ? Number(match[1]) : 1;
        var optionAllocation = (optionVariant.selling_plan_allocations || []).find(function (allocation) {
          return String(allocation.selling_plan_id) === cadencePlanId;
        });
        var subscription = isSubscriptionPurchase(purchaseType) && optionAllocation;
        var price = subscription ? optionAllocation.price : optionVariant.price;
        var meta = label.querySelector('[data-simple-option-meta]');
        // Keep the existing shipping eligibility, including free subscription shipping.
        if (meta) {
          meta.textContent = previewText('unit', {price: money(Math.round(price / size))});
          meta.hidden = false;
          meta.style.display = '';
        }

      });
    });

    compareTargets.forEach(function (target) {
      var isOneTimeRow = Boolean(target.closest('[data-simple-one-time-purchase]'));
      var comparisonPrice = isOneTimeRow ? variant.price : displayPrice;
      var referencePrice = !isOneTimeRow && selectedAllocation ? variant.price : variant.compare_at_price;
      if (referencePrice && referencePrice > comparisonPrice) {
        target.textContent = money(referencePrice);
        target.hidden = false;
        target.style.display = '';
      } else {
        target.hidden = true;
        target.style.display = 'none';
      }
    });

    if (stickyTitle) {
      stickyTitle.textContent = root.getAttribute('data-product-title') + ' - ' + money(displayPrice);
    }

    var subscribed = isSubscriptionPurchase(purchaseType);
    var purchaseError = '';
    if (!expectedPrice) {
      purchaseError = 'This pack is not available for purchase here. Please choose a 3, 6, or 12 pack.';
    } else if (previewUsd && Number(variant.price) !== expectedPrice) {
      purchaseError = 'Pricing for this pack is being updated. Please try again shortly.';
    } else if (!variant.available) {
      purchaseError = 'This pack is currently sold out. Please choose another size.';
    } else if (subscribed && !selectedAllocation) {
      purchaseError = 'This delivery interval is not available for this pack. Please choose another interval or one-time purchase.';
    } else if (subscribed && (previewUsd
      ? Number(selectedAllocation.price) !== Math.round(expectedPrice * 0.8) || renewalPriceFor(selectedAllocation) !== Math.round(expectedPrice * 0.85)
      : !(Number(selectedAllocation.price) > 0 && renewalPriceFor(selectedAllocation) > 0))) {
      purchaseError = 'Subscription pricing for this pack is being updated. Please try again shortly or choose one-time purchase.';
    }
    var canPurchase = !purchaseError;
    root.dataset.purchaseReady = canPurchase ? 'true' : 'false';
    root.querySelectorAll('[data-simple-form] .simple-pdp__purchase-status').forEach(function (notice) {
      notice.hidden = canPurchase;
      notice.textContent = purchaseError;
      notice.setAttribute('role', 'status');
    });
    submitButtons.forEach(function (button) {
      button.disabled = !canPurchase || root.dataset.submitting === 'true';
      var submitText = button.querySelector('[data-simple-submit-text]');
      if (submitText) {
        submitText.textContent = root.dataset.submitting === 'true' ? 'Adding...' : canPurchase ? 'Add to Cart' : variant.available ? 'Temporarily unavailable' : 'Sold Out';
      }
    });

    updateGallery(root, variant);
  }

  var prefetchedShapeUrls = {};

  function prefetchShapeUrl(url) {
    return;
    if (!url || prefetchedShapeUrls[url]) return;

    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
    prefetchedShapeUrls[url] = true;
  }

  function queueShapePrefetch(url) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () {
        prefetchShapeUrl(url);
      });
      return;
    }

    window.setTimeout(function () {
      prefetchShapeUrl(url);
    }, 900);
  }

  function enhanceShapeNavigation(root) {
    root.querySelectorAll('[data-simple-shape-link]').forEach(function (link) {
      var url = link.getAttribute('data-simple-prefetch-url') || link.href;

      queueShapePrefetch(url);
      link.addEventListener('mouseenter', function () {
        prefetchShapeUrl(url);
      });
      link.addEventListener(
        'touchstart',
        function () {
          prefetchShapeUrl(url);
        },
        { passive: true }
      );

      link.addEventListener('click', function () {
        if (link.classList.contains('is-active')) return;

        root.classList.add('is-shape-loading');
        link.classList.add('is-loading');
        link.setAttribute('aria-busy', 'true');
      });
    });
  }

  function selectDefaultPack(root) {
    if (new URLSearchParams(window.location.search).has('variant')) return;

    var sixPackInput = Array.from(root.querySelectorAll('[data-simple-option-group] input[type="radio"]')).find(
      function (input) {
        return /(?:^|\D)6(?:\D|$)/.test(input.value);
      }
    );
    if (!sixPackInput) return;

    sixPackInput.checked = true;
    root.querySelectorAll('petes-perks-carousel[data-perks-mode="fixed"]').forEach(function (perks) {
      perks.setAttribute('data-pack-size', '6');
    });
  }

  document.querySelectorAll('[data-simple-pdp]').forEach(function (root) {
    if (root.dataset.simplePdpReady === 'true') return;
    root.dataset.simplePdpReady = 'true';

    var form = root.querySelector('[data-simple-form]');

    root.addEventListener('change', function () {
      update(root);
    });

    if (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        update(root);
        if (root.dataset.purchaseReady !== 'true' || root.dataset.submitting === 'true') return;
        if (typeof window.addToCartHandler !== 'function') {
          var notice = form.querySelector('.simple-pdp__purchase-status');
          if (notice) {
            notice.hidden = false;
            notice.textContent = 'Your basket is still loading. Please try again in a moment.';
          }
          return;
        }
        root.dataset.submitting = 'true';
        try {
          await Promise.resolve(window.addToCartHandler(form));
        } finally {
          root.dataset.submitting = 'false';
          update(root);
        }
      }, true);

    }

    root.querySelectorAll('[data-simple-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMainImage(root, thumb);
      });
    });

    wireGallerySwipe(root);

    root.querySelectorAll('[data-simple-submit]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.type === 'submit') return;
        root.querySelector('[data-simple-form]').requestSubmit();
      });
    });

    enhanceShapeNavigation(root);
    selectDefaultPack(root);
    update(root);
  });

  document.querySelectorAll('[data-simple-testimonials]').forEach(function (root) {
    if (root.dataset.simpleTestimonialsReady === 'true') return;
    root.dataset.simpleTestimonialsReady = 'true';

    var track = root.querySelector('[data-simple-testimonial-track]');
    var slides = Array.from(root.querySelectorAll('.simple-pdp__testimonial-slide'));
    var dots = Array.from(root.querySelectorAll('[data-simple-testimonial-dot]'));
    var prev = root.querySelector('[data-simple-testimonial-prev]');
    var next = root.querySelector('[data-simple-testimonial-next]');
    var autoplayDelay = 4500;
    var autoplayTimer = null;
    if (!track || !slides.length) return;

    function currentIndex() {
      var width = track.clientWidth || 1;
      return Math.round(track.scrollLeft / width);
    }

    function setActive(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    function go(index) {
      var nextIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: nextIndex * track.clientWidth, behavior: 'smooth' });
      setActive(nextIndex);
    }

    function startAutoplay() {
      if (slides.length < 2) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = window.setInterval(function () {
        go(currentIndex() + 1);
      }, autoplayDelay);
    }

    function restartAutoplay() {
      startAutoplay();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        go(currentIndex() - 1);
        restartAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        go(currentIndex() + 1);
        restartAutoplay();
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        go(index);
        restartAutoplay();
      });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        setActive(currentIndex());
      });
    });

    startAutoplay();
  });
})();
